'use client';

import React from 'react';
import CodeSetVolumeGapV2 from 'src/components/Profiles/shared/widgets/CodeSetVolumeGap/CodeSetVolumeGapV2';

const CompactTreatingVolumeRatioPreview: React.FC = () => <CodeSetVolumeGapV2 />;

export default CompactTreatingVolumeRatioPreview;
